package feature.auth.handler


import androidx.compose.runtime.CompositionLocalContext
import common.constants.KeyConstant
import common.constants.UserDefaults
import common.util.uuid
import component.country.CountryCode
import feature.auth.network.AuthNetwork
import feature.auth.network.UpdateFCMTokenRequest
import feature.auth.repository.AuthRepository
import feature.auth.viewModel.AuthViewModel
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch


class AuthHandler {

    var viewModel: AuthViewModel? = null
    val repository = AuthRepository()
    var context: CompositionLocalContext? = null
    var deviceId = ""
    var otpFromSever = ""
    var mobile = ""
    var dialCode = ""
    var countryCode: CountryCode? = null

    init {
        instance = this
    }

    var onLogout: (() -> Unit)? = null

    fun logout() {
        UserDefaults.remove(KeyConstant.loginDetails)
        if (onLogout != null) {
            onLogout!!()
        }
    }

    companion object {
        private var instance: AuthHandler? = null
        fun shared(): AuthHandler {
            if (instance != null) {
                return instance as AuthHandler
            } else {
                return AuthHandler()
            }
        }
    }

    fun isLoggedIn(): Boolean {
        return repository.isLoggedInState.value
    }

    fun setup(model: AuthViewModel) {
        viewModel = model
    }

    fun updateTokenToServer(
        token: String
    ) {
        isLoggedIn()
        val user = shared().repository.authLiveData.value
        if (!user.id.isNullOrEmpty()) {
            val request = UpdateFCMTokenRequest(user.id, token, uuid())
            CoroutineScope(Job() + Dispatchers.Default).launch {
                AuthNetwork().updateToken(request) {
                    if (it?.status == "Success") {
                        print("FCM Updated in Server")
                    } else {
                        print("Couldn't update FCM Updated in Server")
                    }
                }
            }
        } else {
            UserDefaults.store(
                KeyConstant.fcmToken,
                token
            )
        }
    }

    fun updateExistingTokenToServer(userId: String) {
        val token = UserDefaults.retrieve(KeyConstant.fcmToken)
        if (userId.isNotEmpty() && token.isNotEmpty()) {
            val request = UpdateFCMTokenRequest(userId, token, uuid())
            CoroutineScope(Job() + Dispatchers.Default).launch {
                AuthNetwork().updateToken(request) {
                    if (it?.status == "Success") {
                        print("FCM Updated in Server")
                        UserDefaults.remove(KeyConstant.fcmToken)
                    } else {
                        print("Couldn't update FCM Updated in Server")
                    }
                }
            }
        }
    }
}